// extracted by mini-css-extract-plugin
export default {"section":"views-ProductPage-themes-BGH-sections-productsInSeries__section--uyroG","seriesLink":"views-ProductPage-themes-BGH-sections-productsInSeries__seriesLink--lOz7Y"};